import React, { useContext } from "react";
var FooterLinksContext = /*#__PURE__*/React.createContext();
export var FooterLinksProvider = FooterLinksContext.Provider;

function useFooterLinks() {
  return useContext(FooterLinksContext);
}

export default useFooterLinks;